import { render, staticRenderFns } from "./RedoxCreation.vue?vue&type=template&id=efa8f404&scoped=true"
import script from "./RedoxCreation.vue?vue&type=script&lang=js"
export * from "./RedoxCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa8f404",
  null
  
)

export default component.exports